import { z } from 'zod';
/** Primitives reused across API contracts. */
export const uuidSchema = z.string().uuid('Must be a valid UUID');
/** A 0x-prefixed 20-byte EVM address, normalised to lowercase. */
export const addressSchema = z
    .string()
    .trim()
    .regex(/^0x[0-9a-fA-F]{40}$/, 'Must be a 0x-prefixed 20-byte address')
    .transform((v) => v.toLowerCase());
/** A 32-byte transaction or block hash. */
export const hash32Schema = z
    .string()
    .trim()
    .regex(/^0x[0-9a-fA-F]{64}$/, 'Must be a 0x-prefixed 32-byte hash')
    .transform((v) => v.toLowerCase());
/** A non-negative decimal amount as a string, e.g. "0.05". Never a float. */
export const decimalAmountSchema = z
    .string()
    .trim()
    .regex(/^\d+(\.\d{1,18})?$/, 'Must be a non-negative decimal with at most 18 decimal places');
/** A wei value as a base-10 integer string. */
export const weiSchema = z
    .string()
    .trim()
    .regex(/^\d+$/, 'Must be a non-negative integer string');
export const paginationSchema = z.object({
    limit: z.coerce.number().int().min(1).max(200).default(50),
    cursor: z.string().trim().max(200).optional(),
});
//# sourceMappingURL=common.js.map